var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("input", {
      ref: "file",
      staticStyle: { display: "none" },
      attrs: { type: "file" }
    }),
    _c("div", { ref: "editorRef" }),
    _c(
      "div",
      { ref: "toolbar" },
      [
        _c("button", { staticClass: "ql-bold" }),
        _c("button", { staticClass: "ql-italic" }),
        _c("button", { staticClass: "ql-underline" }),
        _c("button", { staticClass: "ql-list", attrs: { value: "ordered" } }),
        _c("button", { staticClass: "ql-list", attrs: { value: "bullet" } }),
        _c("button", { staticClass: "ql-image" }),
        _vm._l(_vm.toolbarExtras, function(extra) {
          return [
            !extra.options
              ? _c("button", { key: extra.name, class: `ql-${extra.name}` })
              : _c(
                  "select",
                  {
                    key: extra.name,
                    class: `ql-${extra.name}`,
                    attrs: { "data-label": extra.label }
                  },
                  _vm._l(extra.options, function(option) {
                    return _c(
                      "option",
                      { key: option.value, domProps: { value: option.value } },
                      [_vm._v(" " + _vm._s(option.title) + " ")]
                    )
                  }),
                  0
                )
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }